import { SvgDataCatalogLineageDashboard } from '../../../gen-src/icons/DataCatalogLineageDashboard';
import { SvgDataCatalogLineageDashboardActive } from '../../../gen-src/icons/DataCatalogLineageDashboardActive';
import { SvgDataCatalogLineageDashboardWhite } from '../../../gen-src/icons/DataCatalogLineageDashboardWhite';
import { SvgDataCatalogLineageDs } from '../../../gen-src/icons/DataCatalogLineageDs';
import { SvgDataCatalogLineageDsActive } from '../../../gen-src/icons/DataCatalogLineageDsActive';
import { SvgDataCatalogLineageDsWhite } from '../../../gen-src/icons/DataCatalogLineageDsWhite';
import { SvgDataCatalogLineageFlow } from '../../../gen-src/icons/DataCatalogLineageFlow';
import { SvgDataCatalogLineageFlowActive } from '../../../gen-src/icons/DataCatalogLineageFlowActive';
import { SvgDataCatalogLineageFlowWhite } from '../../../gen-src/icons/DataCatalogLineageFlowWhite';
import { SvgDataCatalogLineageLens } from '../../../gen-src/icons/DataCatalogLineageLens';
import { SvgDataCatalogLineageLensActive } from '../../../gen-src/icons/DataCatalogLineageLensActive';
import { SvgDataCatalogLineageLensWhite } from '../../../gen-src/icons/DataCatalogLineageLensWhite';
import { SvgDataCatalogLineageMetric } from '../../../gen-src/icons/DataCatalogLineageMetric';
import { SvgDataCatalogLineageMetricActive } from '../../../gen-src/icons/DataCatalogLineageMetricActive';
import { SvgDataCatalogLineageMetricWhite } from '../../../gen-src/icons/DataCatalogLineageMetricWhite';
import { SvgDataCatalogLineageServer } from '../../../gen-src/icons/DataCatalogLineageServer';
import { SvgDataCatalogLineageServerActive } from '../../../gen-src/icons/DataCatalogLineageServerActive';
import { SvgDataCatalogLineageServerWhite } from '../../../gen-src/icons/DataCatalogLineageServerWhite';
import { SvgDataCatalogLineageSheet } from '../../../gen-src/icons/DataCatalogLineageSheet';
import { SvgDataCatalogLineageSheetActive } from '../../../gen-src/icons/DataCatalogLineageSheetActive';
import { SvgDataCatalogLineageSheetWhite } from '../../../gen-src/icons/DataCatalogLineageSheetWhite';
import { SvgDataCatalogLineageTable } from '../../../gen-src/icons/DataCatalogLineageTable';
import { SvgDataCatalogLineageTableActive } from '../../../gen-src/icons/DataCatalogLineageTableActive';
import { SvgDataCatalogLineageTableWhite } from '../../../gen-src/icons/DataCatalogLineageTableWhite';
import { SvgDataCatalogLineageUsers } from '../../../gen-src/icons/DataCatalogLineageUsers';
import { SvgDataCatalogLineageUsersActive } from '../../../gen-src/icons/DataCatalogLineageUsersActive';
import { SvgDataCatalogLineageUsersWhite } from '../../../gen-src/icons/DataCatalogLineageUsersWhite';
import { SvgDataCatalogLineageVirtualConnection } from '../../../gen-src/icons/DataCatalogLineageVirtualConnection';
import { SvgDataCatalogLineageVirtualConnectionActive } from '../../../gen-src/icons/DataCatalogLineageVirtualConnectionActive';
import { SvgDataCatalogLineageVirtualConnectionTable } from '../../../gen-src/icons/DataCatalogLineageVirtualConnectionTable';
import { SvgDataCatalogLineageVirtualConnectionTableActive } from '../../../gen-src/icons/DataCatalogLineageVirtualConnectionTableActive';
import { SvgDataCatalogLineageVirtualConnectionTableWhite } from '../../../gen-src/icons/DataCatalogLineageVirtualConnectionTableWhite';
import { SvgDataCatalogLineageVirtualConnectionWhite } from '../../../gen-src/icons/DataCatalogLineageVirtualConnectionWhite';
import { SvgDataCatalogLineageWorkbook } from '../../../gen-src/icons/DataCatalogLineageWorkbook';
import { SvgDataCatalogLineageWorkbookActive } from '../../../gen-src/icons/DataCatalogLineageWorkbookActive';
import { SvgDataCatalogLineageWorkbookWhite } from '../../../gen-src/icons/DataCatalogLineageWorkbookWhite';
import { SvgSchemaViewerBlank } from '../../../gen-src/icons/SchemaViewerBlank';

export enum LineageItemType {
  Dashboard = 'dashboard',
  Database = 'database',
  Datasource = 'datasource',
  Flow = 'flow',
  Lens = 'lens',
  Metric = 'metric',
  Sheet = 'sheet',
  Table = 'table',
  User = 'user',
  VirtualConnection = 'virtualConnection',
  VirtualConnectionTable = 'virtualConnectionTable',
  Workbook = 'workbook',
}

export enum IconType {
  inactive = 'inactive',
  active = 'active',
  white = 'white'
}

type SvgIcon = React.ElementType<React.SVGProps<SVGSVGElement>>;

const activeIcons: Record<LineageItemType, SvgIcon> = {
  dashboard: SvgDataCatalogLineageDashboardActive,
  database: SvgDataCatalogLineageServerActive,
  datasource: SvgDataCatalogLineageDsActive,
  flow: SvgDataCatalogLineageFlowActive,
  lens: SvgDataCatalogLineageLensActive,
  metric: SvgDataCatalogLineageMetricActive,
  sheet: SvgDataCatalogLineageSheetActive,
  table: SvgDataCatalogLineageTableActive,
  user: SvgDataCatalogLineageUsersActive,
  virtualConnection: SvgDataCatalogLineageVirtualConnectionActive,
  virtualConnectionTable: SvgDataCatalogLineageVirtualConnectionTableActive,
  workbook: SvgDataCatalogLineageWorkbookActive,
};

const inactiveIcons: Record<LineageItemType, SvgIcon> = {
  dashboard: SvgDataCatalogLineageDashboard,
  database: SvgDataCatalogLineageServer,
  datasource: SvgDataCatalogLineageDs,
  flow: SvgDataCatalogLineageFlow,
  lens: SvgDataCatalogLineageLens,
  metric: SvgDataCatalogLineageMetric,
  sheet: SvgDataCatalogLineageSheet,
  table: SvgDataCatalogLineageTable,
  user: SvgDataCatalogLineageUsers,
  virtualConnection: SvgDataCatalogLineageVirtualConnection,
  virtualConnectionTable: SvgDataCatalogLineageVirtualConnectionTable,
  workbook: SvgDataCatalogLineageWorkbook,
};

const whiteIcons: Record<LineageItemType, SvgIcon> = {
  dashboard: SvgDataCatalogLineageDashboardWhite,
  database: SvgDataCatalogLineageServerWhite,
  datasource: SvgDataCatalogLineageDsWhite,
  flow: SvgDataCatalogLineageFlowWhite,
  lens: SvgDataCatalogLineageLensWhite,
  metric: SvgDataCatalogLineageMetricWhite,
  sheet: SvgDataCatalogLineageSheetWhite,
  table: SvgDataCatalogLineageTableWhite,
  user: SvgDataCatalogLineageUsersWhite,
  virtualConnection: SvgDataCatalogLineageVirtualConnectionWhite,
  virtualConnectionTable: SvgDataCatalogLineageVirtualConnectionTableWhite,
  workbook: SvgDataCatalogLineageWorkbookWhite,
};

export function getIconForContentType(contentType: LineageItemType, iconType?: IconType): SvgIcon {
  const iconDirectory =
    iconType === IconType.active ? activeIcons :
      iconType === IconType.white ? whiteIcons :
        inactiveIcons;
  return iconDirectory[contentType] || SvgSchemaViewerBlank;
}
